import React, { FC, memo, PropsWithChildren } from 'react'

import { ConfirmRedirectModal } from './components/ConfirmRedirectModal'
import { NavigationContainerContext } from './context'

import { useNavigationHandler } from '../hooks/useNavigationHandler'

export const NavigationContainerProvider: FC<PropsWithChildren> = memo(({ children }) => {
  const { allowRedirect, blockRedirect, isRedirectAllowed, isRedirectConfirmationRequired, redirect, resetRedirectRestrictions } =
    useNavigationHandler()

  const value = {
    allowRedirect,
    blockRedirect,
    isRedirectAllowed,
    isRedirectConfirmationRequired,
    redirect,
    resetRedirectRestrictions,
  }

  return (
    <NavigationContainerContext.Provider value={value}>
      {children}
      <ConfirmRedirectModal />
    </NavigationContainerContext.Provider>
  )
})

NavigationContainerProvider.displayName = 'NavigationContainerProvider'
